class Request {
  constructor(axios) {
    this.client = axios.create({
      baseURL: process.env.VUE_APP_API_URL,
      headers: {},
      timeout: 10000,
      withCredentials: true,
    });
  }

  buildPath(path) {
    return process.env.VUE_APP_API_URL + path;
  }

  get(path, params) {
    return this.send(this.configure('GET', path, params, {}, {}));
  }

  post(path, data, headers) {
    return this.send(this.configure('POST', path, {}, data, headers));
  }

  put(path, data) {
    return this.send(this.configure('PUT', path, {}, data, {}));
  }

  patch(path, data) {
    return this.send(this.configure('PUT', path, {}, data, {}));
  }

  delete(path, params) {
    return this.send(this.configure('DELETE', path, params, {}, {}));
  }

  configure(method, path, params, data, headers) {
    return {
      url: path,
      method: method,
      params: params || {},
      headers: headers || {},
      data: data || {},
    };
  }

  send(config) {
    return this.client.request(config);
  }
}

const axios = require('axios');
const request = new Request(axios);

export default request;
